// import store from '@/store'
export default function checkPermission(value,roles) {
    if (value && value instanceof Array && value.length > 0) {
    //   const roles = store.getters && store.getters.roles
      let permissionRoles = value
      let hasPermission = roles.some(role => {
        return permissionRoles.includes(role)
      })
      return hasPermission
    } else {
      console.error(`没有按钮权限！`)
      return false
    }
}